//#region src/services/IWelcomeSettingsConfigService.ts
const WELCOME_SETTINGS_CONFIG_SERVICE_IDENT = "org.bloomstack.service.WelcomeSettingsConfigService";

//#endregion
export { WELCOME_SETTINGS_CONFIG_SERVICE_IDENT };
//# sourceMappingURL=IWelcomeSettingsConfigService.js.map